import React, { useContext } from "react";
import style from "./index.module.scss";
import { Button, Icon, message } from "antd";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import CourseHeader from "../../../components/CourseHeader";
import useRequest from "utils/useRequest";
import {
    ExerciseStatus,
    getExerciseList,
    publishExercise
} from "service/exercise";
import moment from "moment";
import { renderValidityTime } from "utils/common";
import { errorMessage } from "../../../../../service/service";
import usePromiseCallback from "../../../../../utils/usePromiseCallback";

interface ExerciseTopicsHeaderProps {
    exerciseId: string;
    visible: boolean;
}

export default function ExerciseTopicsHeader({
    exerciseId,
    visible
}: ExerciseTopicsHeaderProps) {
    const history = useHistory();
    const { course, basename } = useContext(CourseContext);
    const { weekTimeId } = course;
    const [dataList] = useRequest(() => getExerciseList(weekTimeId), {}, [
        weekTimeId
    ]);
    const currentData = dataList?.find(item => item.id === Number(exerciseId));

    const status =
        currentData &&
        currentData.exerciseCount < 1 &&
        currentData?.exerciseStatus === 0
            ? ExerciseStatus.NoExercise
            : currentData?.exerciseStatus;

    const startExercise = usePromiseCallback(async function () {
        try {
            await publishExercise(weekTimeId, parseInt(exerciseId));
            history.replace(`${basename}/exercise/detail/${exerciseId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    return (
        <CourseHeader
            title={currentData?.description ? currentData.description : ""}
            info={
                <div>
                    <span>
                        活动时长 {renderValidityTime(currentData?.validityTime)}
                    </span>

                    {(currentData?.startTime || currentData?.endTime) && (
                        <span>
                            &nbsp;|&nbsp;
                            {(status === ExerciseStatus.doing ||
                                status === ExerciseStatus.done) &&
                                currentData.startTime && (
                                    <>
                                        开始时间{" "}
                                        {moment(currentData.startTime).format(
                                            "MM-DD HH:mm"
                                        )}
                                        &nbsp;&nbsp;
                                    </>
                                )}
                            {status === ExerciseStatus.done &&
                                currentData.endTime && (
                                    <>
                                        结束时间{" "}
                                        {moment(currentData.endTime).format(
                                            "MM-DD HH:mm"
                                        )}
                                    </>
                                )}
                        </span>
                    )}
                </div>
            }
            extra={
                <Button
                    type="primary"
                    className={style.button}
                    onClick={startExercise}
                    disabled={!visible}>
                    <Icon type="flag" theme="filled" /> 开始活动
                </Button>
            }
        />
    );
}
